export default {

    data() {
        return {
            titleComponent: null,
            showComponent: false,
            colorComponent: "primary",
            sizeComponent: "lg",
            dataComponent: {},

        };
    },
    props: {
        title: String,
        show: Boolean,
        color: String,
        size: String,
        data: Object,
    },

    watch: {
        title() {
            this.titleComponent = this.title;
        },
        show() {
            this.showComponent = this.show;
        },
        color() {
            this.colorComponent = this.color;
        },
        size() {
            this.sizeComponent = this.size;
        },
        showComponent() {
            this.$emit("update:show", this.showComponent);
        },
        data(){
            this.dataComponent = this.data;
        }
    },
    methods: {

        closeModal() {
            this.showComponent = false;
        },

    },
    mounted() {
        this.titleComponent = this.title;
        this.showComponent = this.show;
        this.colorComponent = this.color;
        this.sizeComponent = this.size;
        this.dataComponent = this.data;
        
    },
}